export class MailSchemaCreateModel {
  public StepType?: number;
  public Subject?: string;
  public Body?: string;
}
